import {AfterViewInit, Component, inject, OnInit} from '@angular/core';
import {RetailerBatchSummary} from "../../transactions/transactions.model";
import {DateRange} from "@angular/material/datepicker";
import {TransactionsService} from "../../transactions/transactions.service";
import {UtilsService} from "@shared-services/utils.service";
import {DateUtilsService} from "@shared-services/dateUtils.service";
import {
  CustomDateRangeChangeEventModel
} from "@ui-kit/webkit/components/custom-date-filter/custom-date-range-change-event.model";
import {CustomDateRangeModel, TimeFrames} from "@ui-kit/webkit/components/custom-date-filter/custom-date-range.model";
import {LoadingService} from '@ui-kit/framework/util/service/loading.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {lastValueFrom} from 'rxjs';
import {DistrictPaymentConfig} from '@features/accounts/run-tenant-payouts/model/district-payout-config.model';
import {
  DistrictPayoutsConfigService
} from '@features/accounts/run-tenant-payouts/service/district-payouts-config.service';

@Component({
  selector: 'app-payout-history-list',
  templateUrl: './payout-history-list.component.html',
})
export class PayoutHistoryListComponent implements OnInit, AfterViewInit {
  private _loader = inject(LoadingService);

  displayedColumns = ['paymentBatchUuid',
    'retailerCompanyName',
    'processedDate',
    'earliestTransactionDate',
    'latestTransactionDate',
    'saleAmountIncl',
    'paymentsExternalInclTotal',
    'paymentsCollectedInclTotal',
    'transactionFeeIncl',
    'turnoverRentalFeeIncl',
    'netBalancePayableRetailerInclRounded',
    'processStatus'];

  dateRange: DateRange<Date | null> = new DateRange<Date | null>(null, null);
  dateFilters: CustomDateRangeModel[] = [
    new CustomDateRangeModel('1', 7, TimeFrames.DAYS, 'Last 7 days'),
    new CustomDateRangeModel('2', 0, TimeFrames.MONTH, 'This month')
  ]

  retailerBatchSummary: RetailerBatchSummary[] = [];

  protected readonly retailerBatchSummaryModelType = RetailerBatchSummary;

  amountForm: FormGroup;

  protected loading$ = this._loader.loading$;

  constructor(private transactionsService: TransactionsService,
              public utils: UtilsService,
              public dateUtils: DateUtilsService,
              public payoutsService: DistrictPayoutsConfigService) {
    this.amountForm = new FormGroup({
      uuid: new FormControl({value: '', disabled: false}),
      amount: new FormControl({value: 0, disabled: true}, [Validators.required, Validators.min(0)])
    });
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    lastValueFrom(this.payoutsService.getConfigForOffering())
      .then((res: DistrictPaymentConfig) => {
        this.amountForm.get('uuid')!.setValue(res.uuid);
        this.amountForm.get('amount')!.setValue(res.payoutMinAmount);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  loadPayoutHistory() {
    const filters = [
      {name: 'fromDate', val: this.dateUtils.displayShortDate(this.dateRange.start)},
      {name: 'toDate', val: this.dateRange.end ? this.dateUtils.displayShortDate(this.dateRange.end) : null},
    ]
    this.transactionsService.getPayoutHistoryForDateRange(filters)
      .subscribe({
      next: value => {
        this.retailerBatchSummary = value
      },
      error: err => console.log(err),
    })
  }

  getDateRange(event: CustomDateRangeChangeEventModel) {
    if (event.dateRange.start && event.dateRange.end) {
      this.dateRange = event.dateRange;
      this.loadPayoutHistory()
    }
  }
}
